import React from 'react'
import styles from './sign-out-process.styles'
import injectSheet from 'react-jss'
import Spinner from 'pobble-components/dist/spinner'
import Auth from '../../../auth/auth'

const SignOutProcess = ({ classes }) => (
  <Auth>
    <Spinner className={classes.spinner} />
  </Auth>
)

export default injectSheet(styles)(SignOutProcess)
